import { render, staticRenderFns } from "./RegionListComponent.vue?vue&type=template&id=3dbfa1c0&scoped=true"
import script from "./RegionListComponent.vue?vue&type=script&lang=js"
export * from "./RegionListComponent.vue?vue&type=script&lang=js"
import style0 from "./RegionListComponent.vue?vue&type=style&index=0&id=3dbfa1c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbfa1c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dbfa1c0')) {
      api.createRecord('3dbfa1c0', component.options)
    } else {
      api.reload('3dbfa1c0', component.options)
    }
    module.hot.accept("./RegionListComponent.vue?vue&type=template&id=3dbfa1c0&scoped=true", function () {
      api.rerender('3dbfa1c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/region/RegionListComponent.vue"
export default component.exports